import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import BlueButton from "../../../assets/images/img_blue_panel.png";
import SormeiBackground from "../../../assets/images/img_sormei_wallet.png";

class BalanceHolder extends React.Component {
    constructor() {
        super();
        this.state = {
            style: {},
        }
    }
    componentDidMount() {
    }

    render() {
        const value=this.props.data
        return(
            <Grid alignItems='center' container sm={12} item justify='center' className='wallet-balance'>
                <img src={BlueButton} style={{width:'100%',height:'100%'}} alt=""/>
                <h2 className='wallet-balance-text'>
                    {value}
                </h2>
            </Grid>
        )

    }
}
export default  BalanceHolder